import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PivotMintDetail from "./pages/PivotMintDetail";
import NuvoraDetail from "./pages/NuvoraDetail";
import ICADetail from "./pages/ICADetail";
import KleenCladDetail from "./pages/KleenCladDetail";
import ZentharaDetail from "./pages/ZentharaDetail";
import ZentharaSponsorshipDetail from "./pages/ZentharaSponsorshipDetail";
import KalyvDetail from "./pages/KalyvDetail";
import TapbackDetail from "./pages/TapbackDetail";
import CafetrixLabsDetail from "./pages/CafetrixLabsDetail";
import CafetrixSchedule from "./pages/CafetrixSchedule";
import CafetrixAdminDashboard from "./pages/CafetrixAdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import WebsiteDisclaimer from "./pages/WebsiteDisclaimer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pivotmint" element={<PivotMintDetail />} />
          <Route path="/nuvora" element={<NuvoraDetail />} />
          <Route path="/ica" element={<ICADetail />} />
          <Route path="/kleenclad" element={<KleenCladDetail />} />
          <Route path="/zenthara" element={<ZentharaDetail />} />
          <Route path="/zenthara/sponsorship" element={<ZentharaSponsorshipDetail />} />
          <Route path="/kalyv" element={<KalyvDetail />} />
          <Route path="/tapback" element={<TapbackDetail />} />
          <Route path="/cafetrix-labs" element={<CafetrixLabsDetail />} />
          <Route path="/cafetrix-labs/schedule" element={<CafetrixSchedule />} />
          <Route path="/cafetrix-labs/admin" element={<CafetrixAdminDashboard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/website-disclaimer" element={<WebsiteDisclaimer />} />
        </Routes>
        <ScrollToTop />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
